<template>
    <transition>
        <div class='footer animated fadeInDown ' v-bind:class="{ scorllheader: active }">
            <el-row class='navbarwarp'>
                <el-col :xs="8 " :sm="6 " :md="4 " :lg="3 " :xl="1 ">
                    <!-- <div class="logo " v-show='show'>
                           <img src="../../assets/img/logo1.png" alt=" ">
                    </div> -->
                </el-col>
                <el-col :span="14 " style="float:right;margin-right:50px; ">
                    <div class="nav ">

                        <ul class="navbar ">
                            <li>
                                <router-link to="/home1">首页</router-link>
                            </li>

                            <li>
                                <router-link to="/cz">车主服务</router-link>
                            </li>
                            <li>
                                <router-link to="/parkservice">车场服务</router-link>
                                <!-- <a target="_blank" href="http://120.77.74.59:8080/vppms/Login.d">车场服务</a> -->
                            </li>
                            <li>
                                <!-- <a target="_blank" href="http://120.77.74.59:8080/vppms/Login.d">车场服务</a> -->
                                <router-link to="/shopservice">商户服务</router-link>
                            </li>
                            <li>
                                <router-link to="/government">政府监管</router-link>
                                <!-- <a target="_blank" href="http://120.77.74.59:8080/vppms/Login.d">车场服务</a> -->
                            </li>

                            <li>
                                <router-link to="/information">信息平台</router-link>
                                <!-- <a target="_blank" href="http://120.77.74.59:8080/vppms/Login.d">车场服务</a> -->
                            </li>
                             <li>
                                <router-link to="/community">社区生活</router-link>
                                <!-- <a target="_blank" href="http://120.77.74.59:8080/vppms/Login.d">车场服务</a> -->
                            </li>
                         <!--   <li>
                                <router-link to="/platformservice">开放服务</router-link>
                            </li>-->
                            <li>
                                <router-link to="/aboutus">关于我们</router-link>
                            </li>

                        </ul>
                    </div>
                </el-col>
            </el-row>

        </div>
    </transition>
</template>
<script>
export default {
    name: "yzheader",
    data() {
        return {
            active: false,
            show: true,
            isActive: 0,
            scroll: "",
            cur: 0,
            items: [
                {
                    text: "首页",
                    link: "/home"
                },
                {
                    text: "车主服务",
                    link: "/czservice"
                },
                {
                    text: "车场服务",
                    link: "http://120.77.74.59:8080/vppms/Login.d"
                },
                {
                    text: "商户服务",
                    link: "/shopservice"
                },
                {
                    text: "开放服务",
                    link: "/platformservice"
                }
            ]
        };
    },
    methods: {
        mouseEnter(index) {
            this.isActive = index;
        },
        mouseLeave() {
            this.isActive = null;
        },
        changeclick(index) {
            this.cur = index;
        },
        menu() {
            this.scroll =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            if (this.scroll > window.innerHeight) {
                this.active = true;
                this.show = false;
            } else {
                this.active = false;
                this.show = true;
            }
        }
    },

    mounted() {
        console.log(window.innerHeight);
        console.log(window.innerWidth);
        window.addEventListener("scroll", this.menu);
    }
};
</script>

<style scoped>
.navbarwarp {
  padding-top: 25px;
}
.scorllheader {
  position: fixed;
  top: 0px;
  width: 100%;
  animation: myfirst 5s;
  -webkit-animation: myfirst 5s; /* Safari 和 Chrome */
  z-index: 999;
  background-color: #cccdcf;
}
.footer {
  border-bottom: 1px solid none;
  overflow: hidden;
  height: 100px;
  min-width: 1200px;
}
.logo {
  margin-left: 30px;
}
.logo img {
  width: 195px;
  height: 72px;
}
.logotext {
  margin-bottom: 30px;
  font-weight: 500;
  color: #6875a8;
  font-size: 20px;
}

.navbar {
  height: 70px;
  line-height: 76px;
  float: right;
}
.navbar li {
  display: inline;
  padding: 7px;
  margin-left: 20px;
}
.navbar li a {
  width: 100px;
  color: #398ae8 !important;

  font-size: 18px;
}
.router-link-active {
  background-color: #e5e7e7;
}
.active {
  border-bottom: 1px solid #629de4;
}
@keyframes myfirst {
  from {
    background-color: #ffffff;
  }
  to {
    background-color: #cccdcf;
    color: #ffffff !important;
  }
}

@-moz-keyframes myfirst /* Firefox */ {
  from {
    background-color: #ffffff;
  }
  to {
    background-color: #cccdcf;
    color: #ffffff;
  }
}

@-webkit-keyframes myfirst /* Safari 和 Chrome */ {
  from {
    background-color: #ffffff;
  }
  to {
    background-color: #cccdcf !important;
    color: #ffffff;
  }
}

@-o-keyframes myfirst /* Opera */ {
  from {
    background-color: #ffffff;
  }
  to {
    background-color: #cccdcf;
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/yzheader.vue